export default "__VITE_ASSET__C9PSuh8R__"